/**
 * @file paddle page product
 * @author wanzhongyun
 */

import { useState, useRef } from 'react';
import { IinterProducts } from './../../types';
import './style.less';

const Products:React.FC<IinterProducts> = props => {
    const { title, desc, list } = props;
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const productRef = useRef<HTMLDivElement>(null);

    const handleProductClick = (item: IinterProducts['list'][0], index: number) => {
        setCurrentIndex(index);
        if (productRef.current) {
            productRef.current.style.top = `-${630 * index}px`;
        }
    };

    return <div className='paddle-inter-page-products'>
        <div className='paddle-inter-page-products-title'>{ title }</div>
        <div className='paddle-inter-page-products-desc'>{ desc }</div>
        <div className='paddle-inter-page-products-content'>
            <div className='paddle-inter-page-products-content-nav'>
                {
                    list.map((item, index) => <div
                        className='content-nav'
                        key={item.title}
                        onClick={() => {handleProductClick(item, index)}}
                    >
                            { item.title }
                    </div>)
                }
                <div className='paddle-inter-page-products-content-nav-line' style={{top: `${10 + 51 * currentIndex}px`}}></div>
            </div>

            <div className='products-content-wrapper'>
            <div className='products-content' ref={productRef}>
                {
                    list.map((item, index) => <div className='products-item' key={item.title + index}>
                        {
                            item.itemList.map(ele => <div className='products-item-element' key={ele.title + ele.desc} onClick={() => {window.open(ele.link)}}>
                                <img className='products-item-element-image' src={ele.imageUrl} alt={item.title} />
                                <div className='products-item-element-title'>{ ele.title }</div>
                                <div className='products-item-element-desc'>{ ele.desc }</div>
                                <div className='products-item-element-btn'><span className='products-item-element-btn-line' /><span className='products-item-element-btn-arrow' /></div>
                            </div>)
                        }
                    </div>)
                }
            </div>
            </div>
        </div>
    </div>
};

export default Products;